<template>
  <el-card class="select-office-card">
    <el-row class="select-office-card-row" type="flex" align="middle" style="flex-wrap: wrap; gap: 18px;">
      <div class="image-wrapper">
        <img class="office-avatar" :src="office.imageUrl" />
      </div>
      <div v-if="isVirtualOffice" style="flex-grow: 1;">
        <h3 class="ma-0">Virtual Office</h3>
        <p class="ma-0">Complete your tax return remotely.</p>
      </div>
      <div v-else style="flex-grow: 1;">
        <p class="ma-0">{{ office.address }}</p>
        <p class="ma-0">{{ office.city }}, {{ office.state }} {{ office.zip }}</p>
        <p class="ma-0">{{ office.phone }}</p>
      </div>
      <div class="select-button-container" style="display: flex; flex-direction: column; align-items: center;">
        <el-button :type="!selected ? 'primary' : 'danger'" round @click="onToggleSelect">{{ !selected ? 'Select' : 'Change selection' }}</el-button>
        <small v-show="(office.distanceInMiles > 0)">Distance {{ office.distanceInMiles }} miles</small>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import Office from '@/model/Office';

export default {
  props: {
    office: Office,
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVirtualOffice() {
      return this.office.isVirtualOffice();
    },
  },
  methods: {
    onToggleSelect() {
      if (!this.selected) {
        this.$emit('select', this.office);
      } else {
        this.$emit('unselect', this.office);
      }
    },
  },
};
</script>

<style lang="scss">
.select-office-card {
  line-height: 1.5em;

  .office-avatar {
    width: 120px;
    max-height: 120px;
    border-radius: 10px;
  }

  .el-row > * {
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }
}

@media screen and (min-width: 375px) and (max-width: 650px) {
  .select-office-card {
    .select-button-container {
      width: 100%; // move select button to its own row
    }
  }
}

@media screen and (max-width: 375px) {
  .select-office-card {
    .select-office-card-row {
      flex-direction: column;
    }
  }
}
</style>
